import styled from 'styled-components';
import { VisuallyHidden } from '../../../../../utils.styles';

export const HiddenText = styled.span`
    ${VisuallyHidden};
`;
